var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeSelected({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00002 0.666016C4.40835 0.666016 0.666687 4.40768 0.666687 8.99935C0.666687 13.591 4.40835 17.3327 9.00002 17.3327C13.5917 17.3327 17.3334 13.591 17.3334 8.99935C17.3334 4.40768 13.5917 0.666016 9.00002 0.666016ZM12.625 11.9743C12.5833 12.0454 12.5279 12.1074 12.462 12.1568C12.3961 12.2062 12.321 12.242 12.2412 12.2622C12.1613 12.2824 12.0782 12.2864 11.9968 12.2742C11.9153 12.262 11.8371 12.2337 11.7667 12.191L9.18335 10.6493C8.54169 10.266 8.06669 9.42435 8.06669 8.68268V5.26602C8.06669 4.92435 8.35002 4.64102 8.69169 4.64102C9.03335 4.64102 9.31669 4.92435 9.31669 5.26602V8.68268C9.31669 8.98268 9.56669 9.42435 9.82502 9.57435L12.4084 11.116C12.7084 11.291 12.8084 11.6743 12.625 11.9743V11.9743Z",
    fill: "#075453"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeSelected);
export default __webpack_public_path__ + "static/media/timeSelected.92d6392fa03557cb06704ebef2b84b4e.svg";
export { ForwardRef as ReactComponent };